export default __webpack_public_path__ + "static/media/pink.0194ee60.png";